<script>
    import {
        CardLayout,
        CustomTooltip,
        Loader,
        NotificationModal,
    } from "../../../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../../../Services/index.svelte";

    import {
        getBoolean,
        getGenderType,
        getOpvStatusDVA,
        getOpvStatusHealthFund,
        getOpvStatusMedicare,
        getText,
        getTitle,
        getValidBillingData,
        goToURL,
        showError,
        getTime,
        getFormatBirthDate,
        isObjectEmpty,
        splitCamelCase,
        scrollIntoView,
    } from "../../../../../Utils/utilFunctions.svelte";

    import PatientInsuranceDetails from "../../../../PatientEncounter/components/PatientInsuranceDetails.svelte";

    import { user } from "../../../../../stores";

    import {
        getFormatOpvFailLogs,
        isSufficientTimeToCreateEstimatesOrInvoices,
        loadActivityAndEncounterLogs,
    } from "../../../../PatientEncounter/helpers/encounterHelper.svelte";

    export let patientDetails = {};
    export let billingData = [];
    export let encounterId, patientEncounter;
    export let reloadPatientDetails = () => {};
    export let updatePatientEncounter = () => {};
    export let eclipseLogsData = [];

    $: displayFullName = _getPatientFullName(patientDetails);

    $: isUserAdmin = $user.role == 100;

    let isCheckingOPV = false,
        isSuggestionModalOpen = false,
        isApplyingSuggestion = false;

    let isSendNotificationModalOpen = false,
        isSendingNotificationToPatient = false,
        isNotificationFinishModalOpen = false;

    let suggestedPatientInfo = {};

    let isUpdatingEncounterOpvManuallyApprove = false;

    let isCancelUpdateRequestModalOpen = false,
        isCancelNotificationModalOpen = false;

    let isLoadingLogs = false,
        needRefreshLogs = true,
        latestEclipseLog = {};

    const btnOptions = [
        {
            iconName: "notifyPatientIcon",
            isHidden: false,
            iFont: "fa-regular fa-bell",
            iconFunction: () => _openSendNotificationModal(),
            hasTooltip: false,
            btnText: "Notify patient to update details",
        },
    ];

    $: if (
        patientEncounter?.requestedUpdateDetailsDate &&
        !isSufficientTimeToCreateEstimatesOrInvoices(patientEncounter)
    ) {
        btnOptions[0] = {
            iconName: "cancelNotifyPatientIcon",
            iFont: "fa-regular fa-bell-slash",
            iconFunction: () => (isCancelUpdateRequestModalOpen = true),
            btnText: `Cancel request for patient to update details (sent at ${getTime(patientEncounter.requestedUpdateDetailsDate)})`,
        };
    } else {
        btnOptions[0] = {
            iconName: "notifyPatientIcon",
            iFont: "fa-regular fa-bell",
            iconFunction: () => _openSendNotificationModal(),
            btnText: "Notify patient to update details",
        };
    }

    const runOpvCheck = () => {
        closeSuggestionModal();

        isCheckingOPV = true;

        if (patientDetails.patientEncounterId) {
            apiMethods.postMethod
                .checkOPV({
                    patientEncounterId: patientDetails.patientEncounterId,
                })
                .then((res) => {
                    if (res.error) {
                        isCheckingOPV = false;
                        showError(res.error);
                    } else {
                        _handleOPVSuggestions(res);
                        needRefreshLogs = true;
                        loadLogs();
                    }
                });
        } else {
            isCheckingOPV = false;
            showError(
                "Missing patient encounter id, please contact support...",
            );
        }
    };

    const updateEncounterOpvManuallyApprove = async () => {
        isUpdatingEncounterOpvManuallyApprove = true;

        await apiMethods.putMethod
            .updatePatientEncounter({
                ...patientEncounter,
                opvManuallyApproved: !patientEncounter.opvManuallyApproved,
            }, false, "Fee estimate OPV manually approved")
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to change OPV Manually Approve value, please refresh the page and try again and contact support if the issue persists.",
                    );
                else patientEncounter = { ...res };
            })
            .catch((err) => showError(err));

        isUpdatingEncounterOpvManuallyApprove = false;
    };

    const applySuggestion = async () => {
        isApplyingSuggestion = true;

        if (billingData.length) {
            // update last billing data;
            const lastBillingData = getValidBillingData(billingData);

            if (!lastBillingData || !lastBillingData.id) {
                // no valid billing data;
                isSuggestionModalOpen = false;
                showError("Failed to find valid billing data");
            } else {
                // found valid billing data
                if (suggestedPatientInfo.suggestedMedicareNum)
                    lastBillingData.patientMedicareNo =
                        suggestedPatientInfo.suggestedMedicareNum;
                if (suggestedPatientInfo.suggestedMedicareReference)
                    lastBillingData.patientMedicareRefNo =
                        suggestedPatientInfo.suggestedMedicareReference;
                if (suggestedPatientInfo.suggestedInsuranceId)
                    lastBillingData.patientInsuranceId =
                        suggestedPatientInfo.suggestedInsuranceId;

                if (suggestedPatientInfo.suggestedName)
                    patientDetails.firstName =
                        suggestedPatientInfo.suggestedName;
                if (suggestedPatientInfo.suggestedLastName)
                    patientDetails.lastName =
                        suggestedPatientInfo.suggestedLastName;
                if (suggestedPatientInfo.suggestedBirthdate)
                    patientDetails.birthDate =
                        suggestedPatientInfo.suggestedBirthdate;

                if (
                    suggestedPatientInfo.suggestedName ||
                    suggestedPatientInfo.suggestedLastName ||
                    suggestedPatientInfo.suggestedBirthdate
                )
                    await apiMethods.putMethod.updatePatient(patientDetails);

                billingData.map((bd) => {
                    if (bd.id == lastBillingData.id)
                        bd = { ...lastBillingData };
                });

                await updatePatientEncounter(billingData);
            }
        } else {
            // update patientDetails directly
            if (suggestedPatientInfo.suggestedMedicareNum)
                patientDetails.medicareNo =
                    suggestedPatientInfo.suggestedMedicareNum;
            if (suggestedPatientInfo.suggestedMedicareReference)
                patientDetails.medicareRefNo =
                    suggestedPatientInfo.suggestedMedicareReference;
            if (suggestedPatientInfo.suggestedInsuranceId)
                patientDetails.insuranceId =
                    suggestedPatientInfo.suggestedInsuranceId;
            if (suggestedPatientInfo.suggestedName)
                patientDetails.firstName = suggestedPatientInfo.suggestedName;
            if (suggestedPatientInfo.suggestedLastName)
                patientDetails.lastName =
                    suggestedPatientInfo.suggestedLastName;
            if (suggestedPatientInfo.suggestedBirthdate)
                patientDetails.birthDate =
                    suggestedPatientInfo.suggestedBirthdate;

            await apiMethods.putMethod.updatePatient(patientDetails);

            await updatePatientEncounter();
        }

        closeSuggestionModal();

        isApplyingSuggestion = false;
    };

    const sendNotificationToPatient = async () => {
        _closeSendNotificationModal();

        isSendingNotificationToPatient = true;

        btnOptions[0].isLoading = true;

        await apiMethods.postMethod
            .sendNotifyPatient(encounterId)
            .then((res) => {
                if (getBoolean(res) == "Yes") {
                    reloadPatientDetails(patientDetails.patientEncounterId);
                    _openAfterSendNotificationModal();
                } else
                    showError(
                        "Failed to send notification to patient, please refresh the page and try again and contact support if the issue persists.",
                    );
            });

        btnOptions[0].isLoading = false;

        isSendingNotificationToPatient = false;
    };

    const closeSuggestionModal = () => {
        isCheckingOPV = false;
        isSuggestionModalOpen = false;
        isApplyingSuggestion = false;

        suggestedPatientInfo = {};
    };

    const loadLogs = async () => {
        if (eclipseLogsData.length && !needRefreshLogs) {
            latestEclipseLog = getFormatOpvFailLogs(eclipseLogsData);
            return;
        }

        isLoadingLogs = true;

        const res = await loadActivityAndEncounterLogs(patientEncounter.id);

        if (res.error) showError(res.error);
        else {
            eclipseLogsData = [...res.eclipseLogs];

            latestEclipseLog = getFormatOpvFailLogs(eclipseLogsData);
        }

        isLoadingLogs = false;
        needRefreshLogs = false;
    };

    // HELPER FUNCTIONS
    const _getPatientFullName = (patientInfo) => {
        const { title, firstName, middleName, lastName } = patientInfo;

        let res = "";

        if (title || title == 0) res += `${getTitle(title)} `;
        else res += "Patient ";

        res += `${firstName ?? "-"} ${middleName ?? ""} ${lastName ?? ""}`;

        return res;
    };

    const _getPatientAddress = () => {
        const { address, city, state, postCode } = patientDetails;

        const res = [];

        if (address) res.push(address);
        if (city) res.push(city);
        if (state) res.push(state);
        if (postCode) res.push(postCode);

        return res.join(", ");
    };

    const _redirectToPatient = () => {
        goToURL(`/Patient/view/${patientDetails.id}`);
    };

    const _handleOPVSuggestions = (response) => {
        isCheckingOPV = false;

        const {
            suggestedMedicareNum,
            suggestedMedicareReference,
            suggestedName,
            suggestedLastName,
            suggestedInsuranceId,
            suggestedBirthdate,
        } = response;

        const validSuggestions =
            suggestedMedicareNum ||
            suggestedMedicareReference ||
            suggestedName ||
            suggestedLastName ||
            suggestedInsuranceId ||
            suggestedBirthdate;

        if (!validSuggestions)
            reloadPatientDetails(patientDetails.patientEncounterId);
        else {
            if (suggestedMedicareNum)
                suggestedPatientInfo.suggestedMedicareNum =
                    suggestedMedicareNum;
            if (suggestedMedicareReference)
                suggestedPatientInfo.suggestedMedicareReference =
                    suggestedMedicareReference;
            if (suggestedName)
                suggestedPatientInfo.suggestedName = suggestedName;
            if (suggestedLastName)
                suggestedPatientInfo.suggestedLastName = suggestedLastName;
            if (suggestedInsuranceId)
                suggestedPatientInfo.suggestedInsuranceId =
                    suggestedInsuranceId;
            if (suggestedBirthdate)
                suggestedPatientInfo.suggestedBirthdate = suggestedBirthdate;

            isSuggestionModalOpen = true;
        }
    };

    const _openSendNotificationModal = () =>
        (isSendNotificationModalOpen = true);

    const _closeSendNotificationModal = () =>
        (isSendNotificationModalOpen = false);

    const _openAfterSendNotificationModal = () =>
        (isNotificationFinishModalOpen = true);

    const _closeAfterSendNotificationModal = () =>
        (isNotificationFinishModalOpen = false);

    const cancelPatientNotification = async () => {
        isCancelUpdateRequestModalOpen = false;

        btnOptions[0].isLoading = true;

        await apiMethods.postMethod
            .cancelNotifyPatient(encounterId)
            .then((res) => {
                if (getBoolean(res) == "Yes") {
                    isCancelNotificationModalOpen = true;
                    reloadPatientDetails(patientDetails.patientEncounterId);
                } else
                    showError(
                        "Failed to send notification to patient, please refresh the page and try again and contact support if the issue persists.",
                    );
            });

        btnOptions[0].isLoading = false;
    };

    $: hasDefaultContact = checkPatientContacts(patientDetails);

    let defaultContact;

    const checkPatientContacts = (data) => {
        if (data && data.patientContacts && data.patientContacts.length) {
            defaultContact = data.patientContacts.find((c) => c.useAsContact);
            return !!defaultContact;
        } else {
            defaultContact = null;
            return false;
        }
    };
</script>

<CardLayout title="Patient Details" {btnOptions}>
    <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Full Name:</p>
                <p
                    class="content plink"
                    on:click|preventDefault={_redirectToPatient}
                >
                    {displayFullName}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Gender:</p>
                <p class="content">{getGenderType(patientDetails.sex)}</p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Date of Birth:</p>
                <p class="content">
                    {getFormatBirthDate(patientDetails.birthDate)}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Phone:</p>
                <p class="content">{getText(patientDetails.phone)}</p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Email:</p>
                {#if patientDetails.email}
                    <a
                        href="mailto:{patientDetails.email}"
                        target="_blank"
                        class="content break-all hover:text-[#8A3ED7] hover:underline hover:font-bold"
                    >
                        {getText(patientDetails.email)}
                    </a>
                {/if}
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">UR Number:</p>
                <p class="content">{getText(patientDetails.urNumber)}</p>
            </div>

            {#if hasDefaultContact}
                <div class="flex flex-row gap-x-2">
                    <p class="title">Contact Person:</p>
                    <p
                        on:click={() => scrollIntoView("contactsTable")}
                        class="content plink"
                    >
                        {defaultContact.name}
                    </p>
                </div>
            {/if}

            <div class="flex flex-row gap-x-2">
                <p class="title">Address:</p>
                <p class="content">{_getPatientAddress()}</p>
            </div>
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-2">
            {#if patientDetails.badDebtor || patientDetails.badDebtorByMedicare}
                <div class="cursor-default badge badge-error">
                    {patientDetails.badDebtorByMedicare
                        ? "Bad Debtor recognised by Medicare Number"
                        : "Bad Debtor"}
                </div>
            {/if}

            <PatientInsuranceDetails {patientDetails} {patientEncounter} />
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            {#if patientDetails.insuranceType == 20}
                <div class="flex flex-row gap-x-2">
                    <p class="title">DVA Verification Status:</p>
                    <p
                        class={`content ${
                            patientDetails.opvStatusVeteran == 1
                                ? "text-greenDefault"
                                : patientDetails.opvStatusVeteran == 2 ||
                                    patientDetails.opvStatusVeteran == 3
                                  ? "text-red-400"
                                  : ""
                        }`}
                    >
                        {#if !isCheckingOPV}
                            {getOpvStatusDVA(patientDetails.opvStatusVeteran)}
                        {/if}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Verification manually approved:</p>
                    <p class="content">
                        {getBoolean(patientDetails.opvManuallyApproved)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p
                        class="cursor-pointer underline"
                        on:click|preventDefault={runOpvCheck}
                    >
                        Run DVA Check
                    </p>
                    {#if isCheckingOPV}
                        <Loader />
                    {/if}
                </div>
            {:else}
                <div class="flex flex-row gap-x-2">
                    <p class="title">OPV Status - Medicare:</p>
                    <p
                        class={`content ${
                            patientDetails.opvStatusMedicare == 1
                                ? "text-greenDefault"
                                : patientDetails.opvStatusMedicare == 2 ||
                                    patientDetails.opvStatusMedicare == 3
                                  ? "text-red-400"
                                  : ""
                        }`}
                    >
                        {#if !isCheckingOPV}
                            {getOpvStatusMedicare(
                                patientDetails.opvStatusMedicare,
                            )}
                        {/if}

                        {#if !isCheckingOPV && (patientDetails.opvStatusMedicare == 2 || patientDetails.opvStatusMedicare == 3)}
                            <CustomTooltip
                                contentClass="border-red-400"
                                hoverTriggerFunc={loadLogs}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    class="h-6 w-6 pb-1 shrink-0 stroke-current text-red-400"
                                    slot="tooltipTrigger"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    ></path>
                                </svg>

                                {#if isLoadingLogs}
                                    <div class="flex items-center gap-x-2">
                                        <Loader />
                                        <p>Loading latest log details...</p>
                                    </div>
                                {:else if latestEclipseLog && !isObjectEmpty(latestEclipseLog)}
                                    <div class="flex flex-col gap-y-1">
                                        <p>
                                            Code: {latestEclipseLog
                                                .medicareStatus.status.code}
                                        </p>
                                        <p>
                                            Suggestion: {latestEclipseLog
                                                .medicareStatus.status.text}
                                        </p>
                                    </div>
                                {:else}
                                    <p>No valid Medicare description</p>
                                {/if}
                            </CustomTooltip>
                        {/if}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">OPV Status - Health Fund:</p>
                    <p
                        class={`content ${
                            patientDetails.opvStatusHealthFund == 1
                                ? "text-greenDefault"
                                : patientDetails.opvStatusHealthFund == 2 ||
                                    patientDetails.opvStatusHealthFund == 3
                                  ? "text-red-400"
                                  : ""
                        }`}
                    >
                        {#if !isCheckingOPV}
                            {getOpvStatusHealthFund(
                                patientDetails.opvStatusHealthFund,
                            )}
                        {/if}

                        {#if !isCheckingOPV && (patientDetails.opvStatusHealthFund == 2 || patientDetails.opvStatusHealthFund == 3)}
                            <CustomTooltip
                                contentClass="border-red-400"
                                hoverTriggerFunc={loadLogs}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    class="h-6 w-6 pb-1 shrink-0 stroke-current text-red-400"
                                    slot="tooltipTrigger"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    ></path>
                                </svg>

                                {#if isLoadingLogs}
                                    <div class="flex items-center gap-x-2">
                                        <Loader />
                                        <p>Loading latest log details...</p>
                                    </div>
                                {:else if latestEclipseLog && !isObjectEmpty(latestEclipseLog)}
                                    <div class="flex flex-col gap-y-1">
                                        <p>
                                            Code: {latestEclipseLog
                                                .medicareStatus.status.code}
                                        </p>
                                        <p>
                                            Suggestion: {latestEclipseLog
                                                .healthFundStatus.status.text}
                                        </p>
                                    </div>
                                {:else}
                                    <p>No valid Health Fund description</p>
                                {/if}
                            </CustomTooltip>
                        {/if}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Verification manually approved:</p>
                    <p class="content">
                        {getBoolean(patientDetails.opvManuallyApproved)}
                    </p>
                </div>

                {#if patientDetails.insuranceType == 0 || patientDetails.insuranceType == 11}
                    <div class="flex flex-row gap-x-2">
                        <p
                            class="cursor-pointer underline"
                            on:click|preventDefault={runOpvCheck}
                        >
                            Run OPV Check
                        </p>
                        {#if isCheckingOPV}
                            <Loader />
                        {/if}
                    </div>

                    {#if isUserAdmin}
                        <div class="flex w-full">
                            <p class="title">Manually Approve OPV</p>
                            <input
                                type="checkbox"
                                class="toggle toggle-secondary"
                                disabled={isUpdatingEncounterOpvManuallyApprove}
                                bind:checked={patientEncounter.opvManuallyApproved}
                                on:click={updateEncounterOpvManuallyApprove}
                            />
                        </div>
                    {/if}
                {/if}
            {/if}
        </div>
    </div>
</CardLayout>

<NotificationModal
    title="Verification Failed"
    isModalOpen={isSuggestionModalOpen}
    closeModal={closeSuggestionModal}
    closeModalFunction={closeSuggestionModal}
    cancelText="Cancel"
    confirmAction={applySuggestion}
    submitText={isApplyingSuggestion ? "Applying" : "Apply Suggestion"}
    isConfirming={isApplyingSuggestion}
>
    <div class="flex flex-col gap-y-4">
        <p class="leading-6">Suggestions:</p>
        <!-- <p class="leading-6 text-error">{error}</p> -->
        <div class="flex flex-col gap-y-2 px-6">
            {#each Object.entries(suggestedPatientInfo) as [key, value]}
                {#if value}
                    <p>
                        Change {splitCamelCase(key)} to:
                        <span class="text-error">{value}</span>
                    </p>
                {/if}
            {/each}
        </div>
    </div>
</NotificationModal>

<NotificationModal
    isModalOpen={isSendNotificationModalOpen}
    title="Notify patient to update details"
    closeModal={_closeSendNotificationModal}
    confirmAction={sendNotificationToPatient}
    cancelText="Cancel"
    submitText="Yes"
    closeModalFunction={_closeSendNotificationModal}
>
    <p class="leading-6">
        Once you have asked a patient to update their details, you will not be
        permitted to quote the patient or submit an invoice while you wait for
        them to respond or until 24 hours has elapsed, although you can cancel
        the request once sent.
    </p>
    <p class="leading-6">Are you sure you want to do this?</p>
</NotificationModal>

<NotificationModal
    isModalOpen={isNotificationFinishModalOpen}
    closeModal={_closeAfterSendNotificationModal}
    showConfirmBtn={false}
    closeModalFunction={_closeAfterSendNotificationModal}
>
    Successfully sent notification to patient
</NotificationModal>

<NotificationModal
    isModalOpen={isCancelUpdateRequestModalOpen}
    title="Cancel Patient Notification"
    closeModal={() => (isCancelUpdateRequestModalOpen = false)}
    confirmAction={cancelPatientNotification}
    cancelText="NO"
    submitText="Yes"
    closeModalFunction={() => (isCancelUpdateRequestModalOpen = false)}
>
    Would you like to cancel the request for patient to update details?
</NotificationModal>

<NotificationModal
    isModalOpen={isCancelNotificationModalOpen}
    closeModal={() => (isCancelNotificationModalOpen = false)}
    showConfirmBtn={false}
    closeModalFunction={() => (isCancelNotificationModalOpen = false)}
>
    Successfully cancelled patient update info notification
</NotificationModal>

<style>
    .title {
        width: 200px;
    }

    .content {
        width: calc(100% - 200px);
    }
</style>
